import React from 'react';
import PropTypes from 'prop-types';
import useForm from '@afosto/utils-react/validation/useForm';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Checkbox from '@afosto/app-components-react/Checkbox';
import Form from '@afosto/app-components-react/Form';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import TextField from '@afosto/app-components-react/TextField';
import translations from './translations';

const ItemsAllButtonSettingsForm = ({ onCancel, onSubmit, settings }) => {
  const intl = useIntl();
  const form = useForm({
    defaultValues: {
      minRequestedQuantity: settings?.min_requested_quantity ?? 5,
      atLeastOneProductManually: settings?.at_least_one_product_manually ?? true,
    },
    onCancel,
    onSubmit,
  });

  return (
    <LoadingWrapper isLoading={form.isSubmitting}>
      <Form form={form}>
        <TextField
          name="minRequestedQuantity"
          label={intl.formatMessage(translations.fields.minRequestedQuantity)}
          type="number"
          inputProps={{
            min: 0,
          }}
        />
        <Checkbox
          name="atLeastOneProductManually"
          label={intl.formatMessage(translations.fields.atLeastOneProductManually)}
        />
      </Form>
    </LoadingWrapper>
  );
};

ItemsAllButtonSettingsForm.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  settings: PropTypes.object,
};

ItemsAllButtonSettingsForm.defaultProps = {
  onCancel: undefined,
  onSubmit: undefined,
  settings: undefined,
};

export default ItemsAllButtonSettingsForm;
